import React from 'react';

export default function DropdownList(props) {
  // Ensure that data is an array, even if it's undefined
  const data = Array.isArray(props.data) ? props.data : [];

  // Map the data to options
  const dropdownList = data.map((d) => (
    <option key={d.id} value={d.name}>
      {d.name}
    </option>
  ));

  return (
    <div className="my-6 w-full">
      <div className="my-2">
        {/* Use className conditionally to hide label */}
        <label htmlFor={props.id} className={`${!props.displayLabel ? 'hidden' : ''} mr-1`}>
          {props.label}
        </label>
      </div>
      <div className="-mt-1">
        <select
          className={`p-2 border border-gray-300 h-10 rounded-md ${props.width}`}
          onChange={props.onChange}
          name={props.name}
          id={props.id}
          value={props.value}
        >
          {/* Add a default option if no data is available */}
          {data.length === 0 && <option value="">No options available</option>}
          {dropdownList}
        </select>
      </div>
    </div>
  );
}
